import { Component } from '@angular/core';
import {
  EditorialFeature,
  STATIC_IN_FOCUS,
} from 'src/app/services/home-v2-service';

/**
 * In Focus editorial feature — shared verbatim by Homepage A and B per the
 * frozen designs. STATIC editorial config until a feature endpoint exists.
 */
@Component({
  selector: 'pla-home-in-focus',
  templateUrl: './home-in-focus.component.html',
  styleUrls: ['./home-in-focus.component.scss'],
})
export class HomeInFocusComponent {
  public feature: EditorialFeature = STATIC_IN_FOCUS;
}
